const characters = [
  {
    id: "face_1",
    name: "Mr. Catarowski",
    stats: {
      jerk: 100,
      arrogance: 100,
      cunning: 80,
      health: 100,
    },
  },
  {
    id: "face_2",
    name: "Ms. Samintoreva",
    stats: {
      jerk: 70,
      arrogance: 100,
      cunning: 100,
      health: 100,
    },
  },
];

export default characters;
